"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _AddressValidation = require("../../utils/AddressValidation");

require("./AddressAutoComplete.less");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var AddressAutoComplete = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(AddressAutoComplete, _Component);

  var _super = _createSuper(AddressAutoComplete);

  function AddressAutoComplete(props) {
    var _this;

    (0, _classCallCheck2.default)(this, AddressAutoComplete);
    _this = _super.call(this, props);
    _this.onSelectOption = _this.onSelectOption.bind((0, _assertThisInitialized2.default)(_this));
    _this.state = {
      show: true
    };
    return _this;
  }

  (0, _createClass2.default)(AddressAutoComplete, [{
    key: "onSelectOption",
    value: function onSelectOption(option, i) {
      console.debug('selected option', option);
      this.props.onSelect(option, i);

      if (this.props.hideOnSelect) {
        this.setState({
          show: false
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      if (this.props.candidates.length === 0 || !this.state.show) {
        return /*#__PURE__*/_react.default.createElement("span", null);
      }

      var options = this.props.candidates.map(function (option, i) {
        return /*#__PURE__*/_react.default.createElement("div", {
          className: "address-auto-complete-option",
          key: i,
          onClick: function onClick() {
            return _this2.onSelectOption(option, i);
          }
        }, /*#__PURE__*/_react.default.createElement("span", null, (0, _AddressValidation.flattenAddress)(option)));
      });
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "address-auto-complete"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "address-auto-complete-options-container"
      }, options));
    }
  }], [{
    key: "propTypes",
    get: function get() {
      return {
        candidates: _propTypes.default.array,
        onSelect: _propTypes.default.func,
        hideOnSelect: _propTypes.default.bool
      };
    }
  }, {
    key: "defaultProps",
    get: function get() {
      return {
        candidates: [],
        onSelect: function onSelect() {},
        hideOnSelect: true
      };
    }
  }]);
  return AddressAutoComplete;
}(_react.Component);

exports.default = AddressAutoComplete;